import {defineMessages} from 'react-intl'
import {BRAND_KEY} from '../../brand'

const isKenwood = BRAND_KEY === 'kenwood'
const isBraun = BRAND_KEY === 'braun'

const deliveryBenefitLabels = defineMessages({
    kenwood: {
        defaultMessage: 'Free delivery in 1-3 days ',
        id: 'shipping_services.label.free_delivery.kenwood',
    },
    braun: {
        defaultMessage: 'Free delivery in 1-3 days ',
        id: 'shipping_services.label.free_delivery.braun',
    },
    otherBrands: {
        defaultMessage: 'Free delivery in 1-3 days ',
        id: 'shipping_services.label.free_delivery',
    },
})

const deliveryBlackLabels = defineMessages({
    kenwood: {
        defaultMessage: 'over 25€ ',
        id: 'shipping_services.label.free_delivery.kenwood.black',
    },
    braun: {
        defaultMessage: 'over 25€ ',
        id: 'shipping_services.label.free_delivery.braun.black',
    },
    otherBrands: {
        defaultMessage: 'over 30€ ',
        id: 'shipping_services.label.free_delivery.black',
    },
})

const deliveryBenefitText = isKenwood
    ? deliveryBenefitLabels.kenwood
    : isBraun
    ? deliveryBenefitLabels.braun
    : deliveryBenefitLabels.otherBrands

const deliveryModalSubtitleText = isKenwood
    ? deliveryBlackLabels.kenwood
    : isBraun
    ? deliveryBlackLabels.braun
    : deliveryBlackLabels.otherBrands

export const delivery = {
    benefitText: deliveryBenefitText,
    modalSubtitle: deliveryModalSubtitleText,
    infoPopover: {
        title: {
            id: 'shipping_services.info.popover.free_delivery.title',
            defaultMessage: 'Delivery',
        },
        description: {
            id: 'shipping_services.info.popover.free_delivery.description',
            defaultMessage: 'Free delivery in 1-3 days',
        },
    },
}

export const returns = {
    benefitText: {
        id: 'shipping_services.label.free_returns',
        defaultMessage: 'Free return',
    },
    modalSubtitle: {
        id: 'shipping_services.label.free_returns.black',
        defaultMessage: 'up to 30 days',
    },
    infoPopover: {
        title: {
            id: 'shipping_services.info.popover.free_returns.title',
            defaultMessage: 'Return',
        },
        description: {
            id: 'shipping_services.info.popover.free_returns.description',
            defaultMessage: 'Return Description',
        },
    },
}

export const garanzia = {
    benefitText: {
        id: 'shipping_services.label.garanzia',
        defaultMessage: '2-Year',
    },
    modalSubtitle: {
        id: 'shipping_services.label.garanzia.black',
        defaultMessage: 'included warranty',
    },
    urlLink: {
        id: 'shipping_services.label.garanzia.link',
        defaultMessage: '',
    },
    infoPopover: {
        title: {
            id: 'shipping_services.info.popover.garanzia.title',
            defaultMessage: 'Guarantee',
        },
        description: {
            id: 'shipping_services.info.popover.garanzia.description',
            defaultMessage: 'Guarantee Description',
        },
    },
}

export const benefitDelivery = {
    benefitText: deliveryBenefitText,
    infoPopover: {
        title: {
            id: 'product_view.benefit.benefit_title',
            defaultMessage: "De'Longhi Care",
        },
        description: {
            id: 'product_view.benefit.benefit_description',
            defaultMessage: "Comprehensive protection and support for your De'Longhi product.",
        },
    },
}

export const warranty = {
    benefitText: {
        id: 'product_view.benefit.warranty_text',
        defaultMessage: '2-Year included warranty',
    },
    infoPopover: {
        title: {
            id: 'product_view.benefit.warranty_title',
            defaultMessage: "De'Longhi Care",
        },
        description: {
            id: 'product_view.benefit.warranty_description',
            defaultMessage: "Comprehensive protection and support for your De'Longhi product.",
        },
    },
}
